import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SiteDetail } from '@classes/site-detail';
import { SiteGridComponent } from '../../components/site-grid/site-grid.component';

@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss'],
  styles: [`
  >>> app-site {
    height: 100%;
    display: flex;
  }
`]
})
export class SiteComponent implements OnInit {

  siteForm: FormGroup;
  siteDetail: SiteDetail;

  @ViewChild('SiteGridComponent') siteGridComponent: SiteGridComponent;

  constructor(  ) { }

  ngOnInit() {
  }

  loadSiteDetail(event: any) {
    this.siteDetail = event;
  }

  refreshGrid() {
    this.siteGridComponent.getSites();
  }

}
